<div *ngIf="!isLoading">
    <div class="row">
        <div *ngFor="let artikelDokument of artikelDokumente" class="col_doc">
            <div class="filetypeimage" [ngClass]="getFiletype(artikelDokument.dateityp)"></div>
            <button mat-button (click)="onSelectArtikelDokument(artikelDokument)">{{(artikelDokument.bezeichnung == '' || artikelDokument.bezeichnung == null) ? 'ohne Bezeichnung' : artikelDokument.bezeichnung}}</button>
            <!-- <div  *ngIf="artikelBild.bildKlein != null">
                <img src="data:image/jpeg;base64,{{artikelBild.bildKlein}}" (click)="onSelectImage(artikelBild)"/>
            </div> -->
        </div>
    </div>
</div>